/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-11 11:23:07
 */

import {createRouter,createWebHashHistory} from 'vue-router';
import Layout from '@/layouts/Index.vue';
import Login from '@/views/login/Index.vue';

import NoticeIndex from '@/views/notice/Index.vue';
import NoticeList from '@/views/notice/List.vue';
import NoticeAdd from '@/views/notice/Add.vue';

import FirmwareIndex from '@/views/firmware/Index.vue';
import FirmwareList from '@/views/firmware/List.vue';
import FirmwareAdd from '@/views/firmware/Add.vue';

import CustomerList from '@/views/customer/List.vue';

import CodeList from '@/views/code/List.vue';
import ScanRecord from '@/views/code/ScanRecord.vue';

import SmallProgramIndex from '@/views/smallProgram/Index.vue';
import UserList from '@/views/user/List.vue';

import FaultIndex from '@/views/fault/Index.vue';
import FaultList from '@/views/fault/List.vue';

import FileIndex from '@/views/file/Index.vue';

import ErrorPage from '@/views/404.vue';

const routes = [
    {
        path:'/',
        name:'Index',
        component:Layout,
        redirect:'/Notice/List',
        children:[
            {
                // path:'/Notice',
                // name:'Notice',
                // component:NoticeIndex, 
                // redirect:'/Notice/List',
                path:'/Notice/List',
                name:'NoticeList',
                component:NoticeList,
                meta:{ 
                    title:"公告管理",
                    icon:"HomeOutlined",
                    lang:"menu.notice",
                    isAffix:true,
                    requiresAuth:true
                },
                // children:[
                //     {
                //         path:'/Notice/List',
                //         name:'NoticeList',
                //         component:NoticeList,
                //         meta:{ title:"公告列表",icon:"",lang:"notice.list" }
                //     },
                //     {
                //         path:'/Notice/Add',
                //         name:'NoticeAdd',
                //         component:NoticeAdd,
                //         meta:{ title:"新建公告",icon:"",lang:"notice.add" }
                //     },
                // ]
            },
            {
                // path:'/Firmware',
                // name:'Firmware',
                // component:FirmwareIndex,
                // redirect:'/Firmware/List',
                path:'/Firmware/List',
                name:'FirmwareList',
                component:FirmwareList,
                meta:{ 
                    title:"固件管理",
                    icon:"ApiOutlined",
                    lang:"menu.firmware",
                    requiresAuth:true 
                },
                // children:[
                //     {
                //         path:'/Firmware/List',
                //         name:'FirmwareList',
                //         component:FirmwareList,
                //         meta:{ title:"固件列表",icon:"",lang:"firmware.list" }
                //     }
                // ]
            },
            {
                path:'/Customer/List',
                name:'CustomerList',
                component:CustomerList,
                meta:{  
                    title:"客户管理",
                    icon:"TeamOutlined",
                    lang:"menu.customer",
                    requiresAuth:true 
                },
            },
            {
                path:'/Code/List',
                name:'CodeList',
                component:CodeList,
                meta:{  
                    title:"编码管理",
                    icon:"CodeOutlined",
                    lang:"menu.code",
                    requiresAuth:true 
                },
            },
            {
                path:'/ScanRecord',
                name:'ScanRecord',
                component:ScanRecord,
                meta:{ 
                    title:"扫码记录",
                    icon:"ScanOutlined",
                    lang:"menu.scanRecord",
                    requiresAuth:true 
                },
            },
            {
                path:'/Fault/List',
                name:'Fault',
                component:FaultList,
                meta:{  
                    title:"故障管理",
                    icon:"AlertOutlined",
                    lang:"menu.fault",
                    requiresAuth:true 
                },
            },
            {
                path:'/SmallProgram',
                name:'SmallProgram',
                component:SmallProgramIndex,
                meta:{
                    title:"小程序管理",
                    icon:"CodeSandboxOutlined",
                    lang:"menu.smallProgram",
                    requiresAuth:true
                },
            },
            {
                path:'/File',
                name:'File',
                component:FileIndex,
                meta:{
                    title:"文件管理",
                    icon:"FileOutlined",
                    lang:"menu.file",
                    requiresAuth:true
                },
            },
            {
                path:'/User',
                name:'User',
                component:UserList,
                meta:{ 
                    title:"用户管理",
                    icon:"UserOutlined",
                    lang:"menu.user",
                    requiresAuth:true 
                },
            },
            // {
            //     path:'/Notice/List',
            //     name:'NoticeList',
            //     component:NoticeList,
            //     meta:{ title:"公告列表",icon:"",lang:"notice.list" }
            // },
            {
                path:'/Notice/Add',
                name:'NoticeAdd',
                component:NoticeAdd,
                meta:{ title:"新建公告",icon:"",lang:"notice.add" }
            },
            // {
            //     path:'/Code/Add',
            //     name:'CodeAdd',
            //     component:CodeAdd,
            //     meta:{ title:"新建编码",icon:"",lang:"code.add" }
            // },
            // {
            //     path:'/Firmware/List',
            //     name:'FirmwareList',
            //     component:FirmwareList,
            //     meta:{ title:"固件列表",icon:"",lang:"firmware.list" }
            // }
        ],
    },
    {
        path:'/Login',
        name:'Login',
        component:Login,
    },
    {
        path:'/404',
        name:'404',
        component:ErrorPage,
    },
    {
        path: '/:catchAll(.*)',  // vue3 使用 /:catchAll(.*) 或 /:pathMatch(.*)
        redirect: '/404',
    },
    
]

const router = createRouter({
    history:createWebHashHistory(),
    routes,
})


export default router
